

































import BaseInput from "../models/base.input";
export default class Input extends BaseInput {}
